<div class="main d-flex flex-column">
    <div class="filters d-flex align-items-center gap-3">
        <div class="filter-button-container">
            <button class="d-flex gap-3 align-items-center" (click)="filterOpened = !filterOpened">
                <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 3.75H14M6 14.25H10M4 9H12" stroke="#171717" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
                <span>Filter</span>     
            </button>
            <div *ngIf="filterOpened" class="filters-window">
                <lib-nec-filter 
                    [regions]="geoRegions" 
                    [allAreas]="allSubGeoRegions"
                    [substationTemplates]="substationTemplateOptions"
                    [ratings]="ratingOptions"
                    [filter]="filter"
                    (applyFilter)="onFilterApplied()"
                ></lib-nec-filter>
            </div>
        </div>
        <div class="search-filter d-flex align-items-center">
            <div class="search-type d-flex gap-2 align-items-center" (click)="searchDropdownOpened = !searchDropdownOpened">
                <span>{{ getSearchTypeLabel() }}</span>
                <img height="12" width="12" src="../../../../assets/icons/arrow-down-small.svg" />
            </div>
            <div class="search-bar">
                <img height="16" width="16" src="assets/icons/search.svg" alt="Search icon"/>
                <input
                  type="text"
                  placeholder="Search"
                  [(ngModel)]="filter.searchValue"
                  (keydown.enter)="getAllPowerTransformer()"
                />
            </div>
            <div *ngIf="searchDropdownOpened" class="search-dropdown">
                <ul>
                   <li (click)="selectSearchType(PowerTransformerSearchType.Name)">Asset Name</li> 
                   <li (click)="selectSearchType(PowerTransformerSearchType.SubstationName)">Substation Name</li>
                </ul>
            </div>
        </div>
    </div>
    <div class="table-container">
        <!-- <lib-nec-stats-by-template [selectedEquipment]="'PowerTransformer'"></lib-nec-stats-by-template> -->
        <table>
            <thead>
                <tr>
                    <th class="d-flex align-items-center gap-3">
                        <input class="checkbox" type="checkbox" />
                        <span>
                            Name
                        </span>
                    </th>
                    <th>Rating</th>
                    <th>Primary Winding</th>
                    <th>Secondary Winding</th>
                    <th>Parent Class (Substation)</th>
                    <th>Asset Name</th>
                    <th></th>
                </tr> 
            </thead>
            <tbody>
                <tr *ngFor="let pt of transformers">
                    <td>
                        <div class="cell-content">
                            <input class="checkbox" type="checkbox" />
                            <span>
                                {{ pt.name }}
                            </span>
                        </div>
                    </td>
                    <td>
                        <div class="cell-content">
                            <!-- <img src="../../../assets/icons/v3-bps/IconZap.svg" style="height: 20px;"/> -->
                            <span>
                                {{ pt.rating | hasValue}}
                            </span>
                        </div>
                    </td>
                    <td>
                        <div class="cell-content">
                            <span class="winding yellow">
                                {{ pt.primaryWinding }}
                            </span>
                        </div>
                    </td>
                    <td>
                        <div class="cell-content">
                            <span class="winding orange">
                                {{ pt.secondaryWinding }}
                            </span>
                        </div>
                    </td>
                    <td>
                        <div class="cell-content">
                            <span class="span-padding">
                                {{ pt.parentClass }}
                            </span>
                        </div>
                    </td>
                    <td>
                        <div class="cell-content">
                            <span class="span-padding">
                                {{ pt.parentName | hasValue }}
                            </span>
                        </div>
                    </td>
                    <td class="menu-cell">
                        <div *ngIf="permissionsService.isNetworkEntityClassesCreateEditAllowed" class="menu-wrapper cell-content dots-padding">
                            <div class="dots" (click)="toggleMenu(pt, $event)">
                                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.43647 7.16337L6.15006 9.19769C6.76771 9.6607 7.65378 9.4528 8.00108 8.76344C8.16304 8.44191 8.45676 8.20667 8.80589 8.11883L10.3201 7.73791C11.3039 7.49041 12.0717 6.72137 12.3173 5.7371L13.0568 2.77495M3.43647 7.16337C2.8501 8.31607 2.51953 9.62073 2.51953 11.0026C2.51953 15.6855 6.31579 19.4818 10.9987 19.4818C15.6816 19.4818 19.4779 15.6855 19.4779 11.0026C19.4779 7.02949 16.7452 3.69461 13.0568 2.77495M3.43647 7.16337C4.8372 4.4098 7.69766 2.52344 10.9987 2.52344C11.7085 2.52344 12.3979 2.61065 13.0568 2.77495" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M12.9051 15.5843C13.4236 15.5843 13.8975 15.2915 14.1294 14.8277C14.4373 14.2121 14.2399 13.4635 13.6685 13.0795L12.5205 12.3081C12.157 12.0638 11.7351 11.9204 11.2979 11.8925L10.6919 11.8539C10.3692 11.8332 10.0531 11.9522 9.82404 12.1805C9.44262 12.5605 9.38294 13.1572 9.68168 13.6052L10.2932 14.5225C10.7355 15.1859 11.48 15.5843 12.2773 15.5843H12.9051Z" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>

                            <div class="popup-menu" libPopupMenuFlip *ngIf="actionMenuOpenForId === pt.id">
                                <button *ngIf="permissionsService.isNetworkEntityClassesCreateEditAllowed" class="menu-item"
                                    (click)="selectPt(pt.id)"
                                    data-bs-toggle="modal" data-bs-target="#editAddModal-2"
                                >
                                Update
                                </button>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="bv-pagination py-4">
         <lib-pagination-new
            [totalItems]="count"
            [pageSize]="pageSize"
            [currentPage]="currentPage"
            [pageSizes]="pageSizes"
            (pageChange)="onPageChange($event)"
            (pageSizeChange)="onPageSizeChange($event)">
        </lib-pagination-new>
    </div>
</div>

<lib-nec-add-edit-modal-power-transformer 
    [isOpenedFromSubstation]="false" 
    [selectedPtId]="selectedPtId" 
    [assetRatings]="ratingOptions"
    (ptSaved)="reloadTable()" 
    [hidden]="!modalOpened">
</lib-nec-add-edit-modal-power-transformer>

<lib-nec-add-new-instance-equipment
    [isOpen]="isAddNewInstanceEquipmentOpen"
    (closed)="onAddNewInstanceEquipmentClosed()"
    (proceed)="onAddNewInstanceEquipmentProceed($event)">
</lib-nec-add-new-instance-equipment>

<lib-nec-upload-modal-power-transformer
    [hidden]="!uploadModalOpened" [uploadType]="UploadFileType">
</lib-nec-upload-modal-power-transformer>